var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation d-lg-none",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
          staticClass: "top-area",
        },
        [
          _c("ul", { staticClass: "breadcrumb d-block px-3 py-0" }, [
            _c("li", {
              staticClass: "btn-close",
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" },
            },
            _vm._l(_vm.dataContainer1.categories, function (category, index) {
              return index >= 1
                ? _c(
                    "li",
                    { staticClass: "ddown" },
                    [
                      category.childrenNav && category.childrenNav.length
                        ? [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.slideTo(category)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(category.title) +
                                    "\n                            "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-lg fa-angle-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        : [
                            _c("a", { attrs: { href: category.url } }, [
                              _vm._v(_vm._s(category.title)),
                            ]),
                          ],
                    ],
                    2
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" },
            },
            [
              _vm.dataContainer2.parent
                ? _c("li", { staticClass: "ddown nav-back" }, [
                    _c(
                      "span",
                      {
                        staticClass: "nav-direction btn-up",
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(
                              _vm.dataContainer2.parent || null,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-lg fa-angle-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: _vm.dataContainer2.parent.url } },
                      [_vm._v(_vm._s(_vm.dataContainer2.parent.title))]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c("a", { attrs: { href: category.url } }, [
                    _vm._v(_vm._s(category.title)),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("loading-animation"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "middle-area" }, [
        _c("a", { staticClass: "link-ext", attrs: { href: _vm.bCatLink } }, [
          _vm._v(_vm._s(_vm.bText)),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn-settings",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#shopSettingsWrapper",
              "aria-expanded": "false",
              "aria-controls": "shopSettingsWrapper",
              "aria-label":
                _vm.$translate("Ceres::Template.headerCountry") +
                " " +
                _vm.$translate("Ceres::Template.headerCurrency"),
            },
          },
          [
            _c("i", { class: _vm.lang }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.currency))]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-info bottom-area" },
        _vm._l(_vm.infoText, function (iText) {
          return _c("div", [_vm._v(_vm._s(iText))])
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }